import React, { useEffect } from "react";
import DocumentWidgetItem from "./DocumentWidgetItem";
import { Col, View } from "@amzn/stencil-react-components/layout";
import { DOC_UPLOAD_ITEM_WIDGET_VALID_STATE } from "../../../utility/enums/common";
import { H4, Text } from "@amzn/stencil-react-components/text";
import useArb from "../../../hooks/use-arb";
import { useAppDispatch, useAppSelector } from "../../../reduxStore/reduxHooks";
import { getDocWidgets, updateDocsWidgetFromEDM } from "../../../reduxStore/slices/docUploadSlice";
import { HVH_COLORS } from "../../../config/palette";
import { useGetDocumentsWidgetsQuery } from "../../../reduxStore/api/apiSlice";

const DocumentWidgetList = () => {
  const dispatch = useAppDispatch();
  // TODO: Change the payload into real data when the API ready
  const { data: docs, refetch } = useGetDocumentsWidgetsQuery({
    applicationId: "applicationId",
    bbCandidateId: "bbCandidateId",
  });

  useEffect(() => {
    docs && dispatch(updateDocsWidgetFromEDM({ documents: docs }));
  }, [docs]);

  const docWidgets = useAppSelector(getDocWidgets);
  const { getMessage } = useArb("HVHChecklistPantherResource");

  const widgets = docWidgets.filter((widget) => !widget.markForDeletion);

  const renderHeader = () => {
    const hadProcessingWidget = widgets.find(
      (widget) => widget.state === DOC_UPLOAD_ITEM_WIDGET_VALID_STATE.PROCESSING
    );

    return hadProcessingWidget ? (
      <H4>{getMessage("Checklist-docUpload-widget-list-header-documents-uploading", "Documents Uploading...")}</H4>
    ) : (
      <H4>{getMessage("Checklist-docUpload-widget-list-header-documents-uploaded", "Documents Uploaded")}</H4>
    );
  };

  const renderWidgets = () => {
    return widgets.map((widget) => <DocumentWidgetItem refetch={refetch} key={widget.documentId} doc={widget} />);
  };

  if (widgets.length === 0) return null;

  return (
    <Col padding="S300" gridGap="S300">
      {renderHeader()}
      <View>
        <Text fontSize={"T100"} color={HVH_COLORS.NEUTRAL_70}>
          {getMessage("Checklist-docUpload-widget-list-acceptable-format", "Acceptable format: JPEG, JPG, PDF, PNG")}
        </Text>
        <Text fontSize={"T100"} color={HVH_COLORS.NEUTRAL_70} margin={{ top: 5 }}>
          {getMessage("Checklist-docUpload-widget-list-max-size", "Maximum file size: 7MB")}
        </Text>
      </View>
      {renderWidgets()}
    </Col>
  );
};

export default DocumentWidgetList;
